'use client';

import { c as _c } from "react/compiler-runtime";
import { type KeyboardEvent, useEffect, useRef, useState } from 'react';
import { Dialog, Popover } from 'react-aria-components';
import { type HeaderAccountDropdownContent } from '@module/mdrt-org/shared/components/header/graphql/get-header-profile-dropdown-content';
import { Card } from '@shared/ui-components/card/card';
import { ProfileIcon } from '@shared/ui-components/svgs';
import { KeyboardKey } from '@shared/utils/constants/keyboard-keys';
import { useClickOutside } from '@shared/utils/hooks/use-click-outside';
import { type ProfileSummary } from '../../../../utils/types/profile-summary';
import { ProfileDropdownItems } from '../profile-dropdown-items/profile-dropdown-items';
import { ProfileDropdownSummaryClient } from '../profile-dropdown-summary/profile-dropdown-summary-client';
import { type ProfileDropdownProps } from './types';
import styles from './profile-dropdown-client.module.scss';
const PARENT_CLASSNAME = 'profile-dropdown-client';
export const ProfileDropdownClient = t0 => {
  const $ = _c(31);
  const {
    cmsContent,
    isAuthenticated,
    profileSummary,
    showDisplayName
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const triggerRef = useRef(null);
  const popOverRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = event => {
      if (popOverRef.current && popOverRef.current?.contains(event.target as Node)) {
        return;
      }
      setIsOpen(false);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const wrapperRef = useClickOutside(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = event_0 => {
      if (event_0.key === KeyboardKey.Escape) {
        setIsOpen(false);
      }
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleWrapperKeyUp = t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      const handleScroll = () => setIsOpen(false);
      window.addEventListener("scroll", handleScroll);
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    };
    t4 = [];
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  useEffect(t3, t4);
  let t5;
  if ($[4] !== isOpen) {
    t5 = () => setIsOpen(!isOpen);
    $[4] = isOpen;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ProfileIcon />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = showDisplayName && profileSummary.displayName;
  let t8;
  if ($[7] !== cmsContent.profileDropdownTriggerAriaLabel || $[8] !== t5 || $[9] !== t7) {
    t8 = <button aria-label={cmsContent.profileDropdownTriggerAriaLabel} className={styles[`${PARENT_CLASSNAME}__trigger`]} onClick={t5} ref={triggerRef} type="button">{t6}{t7}</button>;
    $[7] = cmsContent.profileDropdownTriggerAriaLabel;
    $[8] = t5;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== cmsContent || $[12] !== profileSummary) {
    t9 = <ProfileDropdownSummaryClient cmsContent={cmsContent} profileSummary={profileSummary} />;
    $[11] = cmsContent;
    $[12] = profileSummary;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => setIsOpen(false);
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== cmsContent || $[16] !== isAuthenticated) {
    t11 = <ul><ProfileDropdownItems cmsContent={cmsContent} isAuthenticated={isAuthenticated} onClose={t10} /></ul>;
    $[15] = cmsContent;
    $[16] = isAuthenticated;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11 || $[19] !== t9) {
    t12 = <Card className={styles[`${PARENT_CLASSNAME}__content`]} hasSmallRadius={true} ref={popOverRef}>{t9}{t11}</Card>;
    $[18] = t11;
    $[19] = t9;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== cmsContent.profileDropdownAriaLabel || $[22] !== t12) {
    t13 = <Dialog aria-label={cmsContent.profileDropdownAriaLabel}>{t12}</Dialog>;
    $[21] = cmsContent.profileDropdownAriaLabel;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== isOpen || $[25] !== t13) {
    t14 = <Popover className={styles[`${PARENT_CLASSNAME}__popover`]} isNonModal={true} isOpen={isOpen} offset={8} placement="bottom end" triggerRef={triggerRef}>{t13}</Popover>;
    $[24] = isOpen;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t14 || $[28] !== t8 || $[29] !== wrapperRef) {
    t15 = <div className={styles[PARENT_CLASSNAME]} onKeyUp={handleWrapperKeyUp} ref={wrapperRef}>{t8}{t14}</div>;
    $[27] = t14;
    $[28] = t8;
    $[29] = wrapperRef;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  return t15;
};